import React, { useEffect, useState } from 'react'
import { Segment, Worksite } from 'redux/employer/employerTypes'
import { MyCommuter } from 'redux/employee/employeeTypes'
import CommutersTable from '../MyCommuters/CommutersTable'
import SegmentsDrawer from '../components/SegmentsDrawer'
import Loading from 'core-system/Loading'
import { useSelector, useDispatch } from 'react-redux'
import { AppState } from 'redux/config/store'
import { employeeActions } from 'redux/employee/employeeSlice'
import SegmentsUpcomingChanges from './SegmentsUpcomingChanges'
import AlertIcon from 'core-system/Icons/Misc/Alert'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Text from 'core-system/Text'
import SecondaryButton from 'core-system/Button/SecondaryButton'

// Mock segment for the first worksite (seg-1)
const mockHQSegment: Segment = {
  id: 'seg-1',
  name: 'ATL - Airport Operations',
  type: 'WORKSITE',
  commuters: 165,
  archived: false,
}

// Mock segment for the ACS/CGO division
const mockSummerInternsSegment: Segment = {
  id: 'grp-acs-cgo',
  name: 'ACS/CGO',
  type: 'CUSTOM',
  commuters: 311,
  archived: false,
}

// Mock commuters for the ACS/CGO division (grp-acs-cgo)
const mockSummerInternsCommuters: MyCommuter[] = [
  {
    id: 'si1',
    name: 'Alex Rivera',
    email: 'alex.r@delta-demo.com',
    employeeCorporateId: 'DL1001',
    worksiteId: '1',
    totalTrips: 12,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 450.0,
    currentIncentives: 15,
    fleetRemaining: 400,
  },
  {
    id: 'si2',
    name: 'Jordan Taylor',
    email: 'jordan.t@delta-demo.com',
    employeeCorporateId: 'DL1002',
    worksiteId: '2',
    totalTrips: 8,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 475.0,
    currentIncentives: 10,
    fleetRemaining: 425,
  },
  {
    id: 'si3',
    name: 'Casey Morgan',
    email: 'casey.m@delta-demo.com',
    employeeCorporateId: 'DL1003',
    worksiteId: '4',
    totalTrips: 15,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 380.0,
    currentIncentives: 22,
    fleetRemaining: 350,
  },
  {
    id: 'si4',
    name: 'Riley Chen',
    email: 'riley.c@delta-demo.com',
    employeeCorporateId: 'DL1004',
    worksiteId: '1',
    totalTrips: 19,
    programsEnrolled: ['Flex', 'QTF'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 325.0,
    currentIncentives: 28,
    fleetRemaining: 300,
  },
  {
    id: 'si5',
    name: 'Sam Patel',
    email: 'sam.p@delta-demo.com',
    employeeCorporateId: 'DL1005',
    worksiteId: '6',
    totalTrips: 6,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 490.0,
    currentIncentives: 8,
    fleetRemaining: 450,
  },
  {
    id: 'si6',
    name: 'Morgan Lee',
    email: 'morgan.l@delta-demo.com',
    employeeCorporateId: 'DL1006',
    worksiteId: '1',
    totalTrips: 22,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 290.0,
    currentIncentives: 35,
    fleetRemaining: 275,
  },
  {
    id: 'si7',
    name: 'Taylor Kim',
    email: 'taylor.k@delta-demo.com',
    employeeCorporateId: 'DL1007',
    worksiteId: '2',
    totalTrips: 11,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 425.0,
    currentIncentives: 18,
    fleetRemaining: 400,
  },
  {
    id: 'si8',
    name: 'Jamie Wong',
    email: 'jamie.w@delta-demo.com',
    employeeCorporateId: 'DL1008',
    worksiteId: '4',
    totalTrips: 14,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['grp-acs-cgo'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 395.0,
    currentIncentives: 20,
    fleetRemaining: 375,
  },
]

// Mock commuters for HQ (seg-1)
const mockHQCommuters: MyCommuter[] = [
  {
    id: 'c1',
    name: 'Sarah Chen',
    email: 'sarah.chen@delta-demo.com',
    employeeCorporateId: 'DL0001',
    worksiteId: '1',
    totalTrips: 47,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 125.5,
    currentIncentives: 45,
    fleetRemaining: 200,
  },
  {
    id: 'c2',
    name: 'Marcus Johnson',
    email: 'marcus.j@delta-demo.com',
    employeeCorporateId: 'DL0002',
    worksiteId: '1',
    totalTrips: 89,
    programsEnrolled: ['Flex', 'QTF'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 89.0,
    currentIncentives: 120,
    fleetRemaining: 150,
  },
  {
    id: 'c3',
    name: 'Emily Rodriguez',
    email: 'emily.r@delta-demo.com',
    employeeCorporateId: 'DL0003',
    worksiteId: '1',
    totalTrips: 156,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 200.0,
    currentIncentives: 78,
    fleetRemaining: 175,
  },
  {
    id: 'c4',
    name: 'David Kim',
    email: 'david.kim@delta-demo.com',
    employeeCorporateId: 'DL0004',
    worksiteId: '1',
    totalTrips: 23,
    programsEnrolled: ['QTF'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 315.0,
    currentIncentives: 25,
    fleetRemaining: 300,
  },
  {
    id: 'c5',
    name: 'Jessica Patel',
    email: 'jessica.p@delta-demo.com',
    employeeCorporateId: 'DL0005',
    worksiteId: '1',
    totalTrips: 67,
    programsEnrolled: ['Flex', 'GRH'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 156.75,
    currentIncentives: 92,
    fleetRemaining: 225,
  },
  {
    id: 'c6',
    name: 'Michael Thompson',
    email: 'michael.t@delta-demo.com',
    employeeCorporateId: 'DL0006',
    worksiteId: '1',
    totalTrips: 112,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 45.25,
    currentIncentives: 156,
    fleetRemaining: 100,
  },
  {
    id: 'c7',
    name: 'Amanda Lee',
    email: 'amanda.lee@delta-demo.com',
    employeeCorporateId: 'DL0007',
    worksiteId: '1',
    totalTrips: 34,
    programsEnrolled: ['QTF'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 275.0,
    currentIncentives: 38,
    fleetRemaining: 250,
  },
  {
    id: 'c8',
    name: 'Christopher Davis',
    email: 'chris.d@delta-demo.com',
    employeeCorporateId: 'DL0008',
    worksiteId: '1',
    totalTrips: 78,
    programsEnrolled: ['Flex', 'QTF'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 134.5,
    currentIncentives: 87,
    fleetRemaining: 180,
  },
  {
    id: 'c9',
    name: 'Rachel Martinez',
    email: 'rachel.m@delta-demo.com',
    employeeCorporateId: 'DL0009',
    worksiteId: '1',
    totalTrips: 145,
    programsEnrolled: ['Flex'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: false,
    remainingProgramBudget: 67.0,
    currentIncentives: 134,
    fleetRemaining: 125,
  },
  {
    id: 'c10',
    name: 'James Wilson',
    email: 'james.w@delta-demo.com',
    employeeCorporateId: 'DL0010',
    worksiteId: '1',
    totalTrips: 56,
    programsEnrolled: ['GRH'],
    segmentsEnrolled: ['seg-1'],
    competitionsEnrolled: [],
    hasPhysicalCard: true,
    remainingProgramBudget: 189.25,
    currentIncentives: 63,
    fleetRemaining: 210,
  },
]

const AccordionContainer = styled(Accordion)`
  padding: 0;
  box-shadow: 0 0 0 0 !important;
  margin: 0 !important;
  width: 100% !important;
  &::before {
    display: none;
  }
`

const AccordionSummaryContainer = styled(AccordionSummary)`
  padding: 0 0.5rem !important;

  &:hover {
    background-color: ${palette.grey.grey100};
  }
`

const ChangesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`

interface SegmentInfoDrawerProps {
  type: 'worksite' | 'group'
  open: boolean
  closeModal: () => void
  segment?: Segment
  worksite?: Worksite
  commutersAddMode?: boolean
}

const SegmentInfoDrawer = (props: SegmentInfoDrawerProps) => {
  const dispatch = useDispatch()
  const {
    type,
    open,
    closeModal,
    segment,
    worksite,
    commutersAddMode = false,
  } = props

  const [isAdd, setIsAdd] = useState(commutersAddMode)
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    setIsAdd(commutersAddMode)
  }, [commutersAddMode])

  const { myCommuters } = useSelector((state: AppState) => state.employee)
  const { segmentsType, segmentsMap } = useSelector(
    (state: AppState) => state.employer
  )

  const activeSegment = type === 'worksite' ? worksite.segmentId : segment.id

  // Mock segment IDs
  const isMockSegment =
    activeSegment === 'seg-1' || activeSegment === 'grp-acs-cgo'

  // Skip loading for mock segments
  if (!myCommuters && !isMockSegment) {
    return <Loading fullPage />
  }

  const isArchived =
    activeSegment === 'archived' ||
    (segmentsMap && segmentsMap[activeSegment]?.archived)

  const isDeclined = activeSegment === 'declined'

  const activeUpcomingAdditions =
    !isArchived &&
    !isDeclined &&
    segmentsMap &&
    segmentsMap[activeSegment]?.upcomingAdditions

  useEffect(() => {
    // Skip API call for mock segments
    if (isMockSegment) {
      return
    }
    if (
      !myCommuters ||
      (!myCommuters[activeSegment] && Object.keys(myCommuters).length > 0)
    ) {
      dispatch(
        employeeActions.getMyCommuters({
          segment: activeSegment,
        })
      )
    }
  }, [myCommuters, activeSegment, dispatch, isMockSegment])

  const upcomingChanges = !segmentsMap
    ? 0
    : (activeUpcomingAdditions?.length > 0 ||
        segmentsMap[activeSegment]?.upcomingRemovals?.length > 0) &&
      activeUpcomingAdditions?.length +
        (segmentsMap[activeSegment]?.upcomingRemovals?.length || 0)

  const getMockCommuters = () => {
    if (activeSegment === 'seg-1') return mockHQCommuters
    if (activeSegment === 'grp-acs-cgo')
      return mockSummerInternsCommuters
    return []
  }

  const getMockSegment = () => {
    if (activeSegment === 'seg-1') return mockHQSegment
    if (activeSegment === 'grp-acs-cgo') return mockSummerInternsSegment
    return undefined
  }

  const getActiveCommuters = () => {
    if (isAdd) {
      if (isMockSegment) {
        return getMockCommuters()
      }
      return myCommuters?.[activeSegment] ? myCommuters[activeSegment] : []
    }
    return []
  }

  return (
    <SegmentsDrawer
      title={type === 'worksite' ? 'Worksite Details' : 'Group Details'}
      open={open}
      onCloseModal={closeModal}
      titleRightComponent={
        type === 'group' ? (
          <>
            <SecondaryButton
              onClick={() => setIsAdd(true)}
              disabled={isAdd || isEdit}
            >
              Add Commuters
            </SecondaryButton>
            <SecondaryButton
              onClick={() => setIsEdit(true)}
              disabled={isEdit || isAdd}
            >
              Manage Commuters
            </SecondaryButton>
          </>
        ) : (
          <></>
        )
      }
    >
      {upcomingChanges && (
        <AccordionContainer>
          <AccordionSummaryContainer
            expandIcon={
              <KeyboardArrowDownIcon
                sx={{ color: palette.primary.pink800, fontSize: '2rem' }}
              />
            }
          >
            <ChangesContainer>
              <AlertIcon
                height={22}
                width={22}
                color={palette.secondary.purple600}
              />
              <Text variant='action2'>{upcomingChanges} Upcoming Changes</Text>
            </ChangesContainer>
          </AccordionSummaryContainer>
          <AccordionDetails>
            <SegmentsUpcomingChanges
              custom={
                segmentsMap
                  ? segmentsMap[activeSegment]?.type === 'CUSTOM'
                  : false
              }
              activeSegmentId={activeSegment}
              upcomingAdditions={activeUpcomingAdditions}
              upcomingRemovals={
                segmentsMap ? segmentsMap[activeSegment]?.upcomingRemovals : []
              }
            />
          </AccordionDetails>
        </AccordionContainer>
      )}
      <CommutersTable
        myCommuters={
          isAdd
            ? myCommuters?.[segmentsType?.all?.[0]?.id] || []
            : isMockSegment
              ? getMockCommuters()
              : myCommuters?.[activeSegment] || []
        }
        activeCommuters={getActiveCommuters()}
        isAdd={isAdd}
        isEdit={isEdit}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        activeSegment={
          isMockSegment ? getMockSegment() : segmentsMap?.[activeSegment]
        }
        resetPaginationOnRowsChange={!(isAdd || isEdit)}
      />
    </SegmentsDrawer>
  )
}

export default SegmentInfoDrawer
